import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Snippet } from 'react-instantsearch';

import ResultsTile from '../../../../templates/plp/results/tile';

export const HitLink = ({ hit, className }) => (
	<Link
		to={hit.url}
		className='no-underline'
	>
		<div className={`hit-wrapper flex h-full flex-col border border-gray-15 bg-white p-5 transition-all hover:shadow-lg ${className || ''}`}>
			{hit.seo && hit.seo.thumbnail && (
				<img
					src={hit.seo.thumbnail.url + '?height=250&format=pjpg&auto=webp'}
					alt=''
					loading='lazy'
					className='hit-image block h-auto max-h-[100px] w-full object-contain object-center sm:max-h-[200px]'
				/>
			)}

			<p className='hit-title mb-2.5 mt-5 text-base font-semibold'>{hit.title}</p>

			<Snippet
				className='hit-description my-0'
				attribute='description'
				hit={hit}
			/>
		</div>
	</Link>
);

HitLink.propTypes = {
	hit: PropTypes.object,
	className: PropTypes.string,
};

export const ProductHitLink = ({ hit, data, className }) => {
	const image = hit.product_tile?.image_url || hit.product_tile?.manual_image?.url || hit.seo?.thumbnail?.url;
	const tile = { ...hit.product_tile, static_url: null, price: data, image_url: image };

	return (
		<Link
			to={hit.product_tile?.static_url}
			className='block h-full no-underline'
		>
			<ResultsTile
				tile={tile}
				className={`h-full hover:shadow-[0_2px_4px_rgba(0,0,0,0.05)] ${className || ''}`}
				hideCompare
			/>
		</Link>
	);
};

ProductHitLink.propTypes = {
	hit: PropTypes.object,
	data: PropTypes.object,
	className: PropTypes.string,
};

export const NoImageHitLink = ({ hit, className }) => (
	<Link
		to={hit.url}
		className='no-underline'
	>
		<div className={`hit-wrapper flex h-full flex-col border border-gray-15 bg-white p-5 transition-all hover:shadow-lg ${className || ''}`}>
			<p className='hit-title mb-2.5 mt-0 text-base font-semibold'>{hit.title}</p>

			<Snippet
				className='hit-description my-0'
				attribute='description'
				hit={hit}
			/>
		</div>
	</Link>
);

NoImageHitLink.propTypes = {
	hit: PropTypes.object,
	className: PropTypes.string,
};
